export default "__VITE_ASSET__DZMfZE1z__"